module.exports = __webpack_public_path__ + "video/compare.mp4.8332e44.mp4";